<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
        <path
            d="M59.3 22.1A29 29 0 1 1 41.9 4.7"
            stroke="#808d9a"
            stroke-width="3"
            stroke-linecap="round"
        />
        <path
            d="M20 33L30.5 43L61 11"
            stroke="#1fc95b"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
